import React, { lazy } from 'react';
import { PieChart2Line } from '@datanomik/commons-ui/icons';

const CashFlowsMainPage = lazy(() =>
  import('./pages/CashFlowsMainPage').then((m) => ({ default: m.CashFlowsMainPage })),
);

export const getCashFlowsV2Routes = () => [
  {
    path: '',
    key: 'cash-flows',
    label: 'Cash Flow',
    element: <CashFlowsMainPage />,
    icon: <PieChart2Line />,
  },
];
